import AvatarCropper from './AvatarCropper';

export default AvatarCropper;
